import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';
import { ProjectRule } from '..';

const project = {
  getProjectRule: (projectCode: string) => {
    const params = { ...getNormalParams('getProjectRule'), projectCode };
    return FastApiAxiosInstance.get<ProjectRule>('/api/v1/project/getProjectRule', {
      params,
    });
  },
};

export default project;
